import React, { useContext } from 'react';
import { Box, Button } from '@mui/material';
import { useModal } from '../../../../hooks/Modal';
import { ModalTitle, ModalText } from './styled';
import { DefaultCollectContext } from '../..';

export const ModalRemoveFile = () => {
  const { Modal, closeModal } = useModal();

  const {
    otherFiles,
    setOtherFiles,
    removeFile,
    setRemoveFile,
    useForceUpdate
  } = useContext(DefaultCollectContext);

  const forceUpdate = useForceUpdate();

  const handleRemove = () => {
    const indexFile = otherFiles.findIndex((file) => file.id === removeFile);

    const newInvoiceFiles = [...otherFiles];

    newInvoiceFiles.splice(indexFile, 1);

    setOtherFiles(newInvoiceFiles);

    forceUpdate();
    setRemoveFile('');
    closeModal();
  };

  return (
    <Modal>
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 16
        }}
      >
        <ModalTitle>Atenção</ModalTitle>

        <ModalText>
          O arquivo anexado será excluído da solicitação.
          <br />
          Deseja continuar?
        </ModalText>

        <Box
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: 32,
            marginTop: 16
          }}
        >
          <Button
            type="button"
            data-testid="rejectRemoveFileModalButton"
            variant="contained"
            color="error"
            onClick={closeModal}
          >
            Não
          </Button>
          <Button
            type="button"
            data-testid="acceptRemoveFileModalButton"
            variant="contained"
            onClick={handleRemove}
          >
            Sim
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
